// extracted by mini-css-extract-plugin
export default {"lastValuesContainer":"LuminaireLastValuesMetrics_lastValuesContainer__imcbQ","metricsGrid":"LuminaireLastValuesMetrics_metricsGrid__LExYX"};